import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { DivisionsTableDefinitionZod } from '../../division/tables';
import { CorporationsTableDefinitionZod } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaCorporationResolver_List = z.array(
    CorporationsTableDefinitionZod.extend({
        divisions: z.array(DivisionsTableDefinitionZod),
    }),
);

export type SchemaCorporationResolver_List = z.infer<typeof schemaCorporationResolver_List>;

export type CorporationResolver_List = Resolver<Arguments, SchemaCorporationResolver_List>;
